const userAgent = {};

if (/(android)/i.test(navigator.userAgent)) {
  userAgent.android = true;
  userAgent.androidVersion = parseFloat(
    navigator.userAgent.slice(navigator.userAgent.indexOf('Android') + 8),
  );
} else if (/iP(hone|od|ad)/.test(navigator.platform)) {
  const v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
  userAgent.iOS = true;
  userAgent.iOSVersion = [
    parseInt(v[1], 10),
    parseInt(v[2], 10),
    parseInt(v[3] || 0, 10),
  ];
} else if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
  userAgent.firefox = true;
} else if (document.documentMode || /Edge/.test(navigator.userAgent)) {
  userAgent.ie = true;
}

// export const USER_AGENT = {
//   ...userAgent,
// };

/* throttle from underscore */
export function throttle(func, wait, options) {
  var context, args, result;
  var timeout = null;
  var previous = 0;
  if (!options) options = {};
  var later = function() {
    previous = options.leading === false ? 0 : new Date();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };
  return function() {
    var now = new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };
};

// output numbers with commas
export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function whichTransitionEvent(){
  var t;
  var el = document.createElement('fakeelement');
  var transitions = {
    'transition':'transitionend',
    'OTransition':'oTransitionEnd',
    'MozTransition':'transitionend',
    'WebkitTransition':'webkitTransitionEnd'
  }

  for(t in transitions){
    if( el.style[t] !== undefined ){
      return transitions[t];
    }
  }
};

/*
* el: DOM element
* partially: boolean
*/
export function isInViewport(el, partially = false) {
  const b = el.getBoundingClientRect();
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  if(partially) {
    const vertInView = (b.top <= windowHeight) && ((b.top + b.height) >= 0);
    const horInView = (b.left <= windowWidth) && ((b.left + b.width) >= 0);
    return (vertInView && horInView);
  } else {
    return ((b.left >= 0) && (b.top >= 0) && ((b.left + b.width) <= windowWidth) && ((b.top + b.height) <= windowHeight));
  }
}


function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}

export function doScrolling(element, duration) {
  var startingY = window.pageYOffset
  var elementY = getElementY(element)
  // If element is close to page's bottom then window will scroll only to some position above the element.
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
  var diff = targetY - startingY
  // Easing function: easeInOutCubic
  // From: https://gist.github.com/gre/1650294
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start

  if (!diff) return

  // Bootstrap our animation - it will get called right before next frame shall be rendered.
  window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    // Elapsed miliseconds since start of scrolling.
    var time = timestamp - start
    // Get percent of completion in range [0, 1].
    var percent = Math.min(time / duration, 1)
    // Apply the easing.
    // It can cause bad-looking slow frames in browser performance tool, so be careful.
    percent = easing(percent)

    window.scrollTo(0, startingY + diff * percent)

    // Proceed with animation as long as we wanted it to.
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}

export function normalize(val, min, max) {
  return (val - min) / (max - min);
}

export function lerp(v0, v1, t) {
  return v0 * (1 - t) + v1 * t;
}

// calculate distance between two lat and long
export function calculateDistance(lat1, lon1, lat2, lon2, unit) {
  const radlat1 = Math.PI * lat1/180
  const radlat2 = Math.PI * lat2/180
  const radlon1 = Math.PI * lon1/180
  const radlon2 = Math.PI * lon2/180
  const theta = lon1-lon2
  const radtheta = Math.PI * theta/180
  let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  dist = Math.acos(dist)
  dist = dist * 180/Math.PI
  dist = dist * 60 * 1.1515
  if (unit=="K") { dist = dist * 1.609344 }
  if (unit=="N") { dist = dist * 0.8684 }
  return dist
}


























